import {
    GET_STATIC_PAGE,
    GET_INVITE_DATA,
    GET_DECRYPT_DATA,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
    GET_COMPANY_OWNER_DATA,
    GET_SKYFLOW_CARDS,
} from './userTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_STATIC_PAGE:
            return {
                ...state,
                static_page: action.payload,
            }
        case GET_DECRYPT_DATA:
            return {
                ...state,
                decrypt_user: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_INVITE_DATA:
            return {
                ...state,
                invite_data: action.payload,
            }
        case GET_COMPANY_OWNER_DATA:
            return {
                ...state,
                company_owner_data: action.payload,
            }
        case GET_SKYFLOW_CARDS:
            return {
                ...state,
                skyflow_cards: action.payload,
            }
        default:
            return state
    }
}
